import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchWithAuthBaseQuery } from '#shared/api';
import type { DataWithValidation } from '#shared/api';

import {
  validateWeatherSnapshotResponse,
  type WeatherSnapshotResponse,
} from './schemas';

const paths = {
  weatherSnapshot: 'api/weather/snapshot',
} as const;

// The only weather API left after the raw-NOAA aviation-weather feed was
// removed (TMDXNC-45): this hits the BE-composed `GET /api/weather/snapshot`
// initial-state endpoint (TMDXNC-13), which returns a bare object (no
// `{data, dataGeneratedAt, ...}`
// envelope) — see weatherSnapshotResponse.schema.ts for why `transformResponse`
// runs its own `validateWeatherSnapshotResponse` instead of
// `validateAndTransformResponse`.
export const weatherSnapshotApi = createApi({
  reducerPath: 'weatherSnapshotApi',
  baseQuery: fetchWithAuthBaseQuery,
  refetchOnReconnect: true,
  endpoints: build => ({
    getWeatherSnapshot: build.query<
      DataWithValidation<WeatherSnapshotResponse>,
      void
    >({
      query: () => paths.weatherSnapshot,
      transformResponse: (response: unknown) =>
        validateWeatherSnapshotResponse(response),
    }),
  }),
});

export const { useGetWeatherSnapshotQuery } = weatherSnapshotApi;
